import {
  DropZone,
  ComponentConfig,
  WithPuckProps,
  WithId,
} from "@measured/puck";

export interface WrapperProps {
  backgroundColor?: string;
  backgroundImage?: string;
  options?: {
    desktop?: {
      marginTop?: number;
      marginBottom?: number;
      marginLeft?: number;
      marginRight?: number;
      paddingTop?: number;
      paddingBottom?: number;
      paddingLeft?: number;
      paddingRight?: number;
      width?: string;
      height?: string;
      show?: boolean;
    };
    tablet?: {
      marginTop?: number;
      marginBottom?: number;
      marginLeft?: number;
      marginRight?: number;
      paddingTop?: number;
      paddingBottom?: number;
      paddingLeft?: number;
      paddingRight?: number;
      width?: string;
      height?: string;
      show?: boolean;
    };
    mobile?: {
      marginTop?: number;
      marginBottom?: number;
      marginLeft?: number;
      marginRight?: number;
      paddingTop?: number;
      paddingBottom?: number;
      paddingLeft?: number;
      paddingRight?: number;
      width?: string;
      height?: string;
      show?: boolean;
    };
  };
}

const Wrapper = (props: WithId<WithPuckProps<WrapperProps>>) => {
  const { options, id } = props;
  const uniqueClass = `flex-responsive-${id}`;

  return (
    <div>
      <style>
        {`
          @media only screen and (max-width: 743px) {
            .${uniqueClass} {
              margin-top: ${options?.mobile?.marginTop ?? 0}px;
              margin-bottom: ${options?.mobile?.marginBottom ?? 0}px;
              margin-left: ${options?.mobile?.marginLeft ?? 0}px;
              margin-right: ${options?.mobile?.marginRight ?? 0}px;
              padding-top: ${options?.mobile?.paddingTop ?? 0}px;
              padding-bottom: ${options?.mobile?.paddingBottom ?? 0}px;
              padding-left: ${options?.mobile?.paddingLeft ?? 0}px;
              padding-right: ${options?.mobile?.paddingRight ?? 0}px;
              width: ${options?.mobile?.width ?? "100%"};
              height: ${options?.mobile?.height ?? "auto"};
              display: ${options?.mobile?.show ? "block" : "none"}
            }
          }
           @media only screen and (min-width: 744px) and (max-width: 1023px) {
            .${uniqueClass} {
              margin-top: ${options?.tablet?.marginTop ?? 0}px;
              margin-bottom: ${options?.tablet?.marginBottom ?? 0}px;
              margin-left: ${options?.tablet?.marginLeft ?? 0}px;
              margin-right: ${options?.tablet?.marginRight ?? 0}px;
              padding-top: ${options?.tablet?.paddingTop ?? 0}px;
              padding-bottom: ${options?.tablet?.paddingBottom ?? 0}px;
              padding-left: ${options?.tablet?.paddingLeft ?? 0}px;
              padding-right: ${options?.tablet?.paddingRight ?? 0}px;
              width: ${options?.tablet?.width ?? "100%"};
              height: ${options?.tablet?.height ?? "auto"};
              display: ${options?.tablet?.show ? "block" : "none"}
            }
          }
           @media only screen and (min-width: 1024px) and (max-width: 10000px) {
            .${uniqueClass} {
              margin-top: ${options?.desktop?.marginTop ?? 0}px;
              margin-bottom: ${options?.desktop?.marginBottom ?? 0}px;
              margin-left: ${options?.desktop?.marginLeft ?? 0}px;
              margin-right: ${options?.desktop?.marginRight ?? 0}px;
              padding-top: ${options?.desktop?.paddingTop ?? 0}px;
              padding-bottom: ${options?.desktop?.paddingBottom ?? 0}px;
              padding-left: ${options?.desktop?.paddingLeft ?? 0}px;
              padding-right: ${options?.desktop?.paddingRight ?? 0}px;
              width: ${options?.desktop?.width ?? "100%"};
              height: ${options?.desktop?.height ?? "auto"};
              display: ${options?.desktop?.show ? "block" : "none"}
            }
          }
        `}
      </style>

      <div
        className={uniqueClass}
        style={{
          backgroundColor: props.backgroundColor,
          backgroundImage: props.backgroundImage
            ? `url(${props.backgroundImage})`
            : undefined,
        }}
      >
        <DropZone zone="wrapper" />
      </div>
    </div>
  );
};

export const PuckWrapper: ComponentConfig<WrapperProps> = {
  label: "Wrapper",
  fields: {
    backgroundColor: {
      type: "text",
      label: "Background Color",
    },
    backgroundImage: {
      type: "text",
      label: "Background Image",
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        desktop: {
          type: "object",
          label: "Desktop",
          objectFields: {
            marginTop: { type: "number", label: "Margin Top" },
            marginBottom: { type: "number", label: "Margin Bottom" },
            marginLeft: { type: "number", label: "Margin Left" },
            marginRight: { type: "number", label: "Margin Right" },
            paddingTop: { type: "number", label: "Padding Top" },
            paddingBottom: { type: "number", label: "Padding Bottom" },
            paddingLeft: { type: "number", label: "Padding Left" },
            paddingRight: { type: "number", label: "Padding Right" },
            width: { type: "text", label: "Width" },
            height: { type: "text", label: "Height" },
            show: {
              type: "radio",
              label: "Show",
              options: [
                { label: "Show", value: true },
                { label: "Hidden", value: false },
              ],
            },
          },
        },
        tablet: {
          type: "object",
          label: "Tablet",
          objectFields: {
            marginTop: { type: "number", label: "Margin Top" },
            marginBottom: { type: "number", label: "Margin Bottom" },
            marginLeft: { type: "number", label: "Margin Left" },
            marginRight: { type: "number", label: "Margin Right" },
            paddingTop: { type: "number", label: "Padding Top" },
            paddingBottom: { type: "number", label: "Padding Bottom" },
            paddingLeft: { type: "number", label: "Padding Left" },
            paddingRight: { type: "number", label: "Padding Right" },
            width: { type: "text", label: "Width" },
            height: { type: "text", label: "Height" },
            show: {
              type: "radio",
              label: "Show",
              options: [
                { label: "Show", value: true },
                { label: "Hidden", value: false },
              ],
            },
          },
        },
        mobile: {
          type: "object",
          label: "Mobile",
          objectFields: {
            marginTop: { type: "number", label: "Margin Top" },
            marginBottom: { type: "number", label: "Margin Bottom" },
            marginLeft: { type: "number", label: "Margin Left" },
            marginRight: { type: "number", label: "Margin Right" },
            paddingTop: { type: "number", label: "Padding Top" },
            paddingBottom: { type: "number", label: "Padding Bottom" },
            paddingLeft: { type: "number", label: "Padding Left" },
            paddingRight: { type: "number", label: "Padding Right" },
            width: { type: "text", label: "Width" },
            height: { type: "text", label: "Height" },
            show: {
              type: "radio",
              label: "Show",
              options: [
                { label: "Show", value: true },
                { label: "Hidden", value: false },
              ],
            },
          },
        },
      },
    },
  },
  defaultProps: {
    options: {
      desktop: { show: true },
      tablet: { show: true },
      mobile: { show: true },
    },
  },
  render: (props) => <Wrapper {...props} />,
};
